import { render } from "./ModalCreateTeams.vue?vue&type=template&id=9aefea4c&scoped=true"
import script from "./ModalCreateTeams.vue?vue&type=script&lang=js"
export * from "./ModalCreateTeams.vue?vue&type=script&lang=js"

import "./ModalCreateTeams.vue?vue&type=style&index=0&id=9aefea4c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9aefea4c"

export default script